export default __webpack_public_path__ + "static/media/x-circle.0c2c6d43.svg";